import React from 'react';
import { useNavigate } from 'react-router-dom';
import * as Icon from 'react-feather';
import MainStructure from '../../components/general/MainStructure';

const toolCards = [
  {
    id: 'carousel',
    icon: <Icon.Layout size={28} color="#4f46e5" />,
    title: 'Carousel Creator',
    description: 'Upload images, write slide captions, and schedule carousel posts to Instagram',
    action: '/creator-studio/carousel',
    comingSoon: false,
  },
  {
    id: 'video',
    icon: <Icon.Video size={28} color="#4f46e5" />,
    title: 'Video Editor',
    description: 'Add styled text overlays to your videos and export them to your library',
    action: '/creator-studio/video',
    comingSoon: false,
  },
  {
    id: 'story',
    icon: <Icon.Smartphone size={28} color="#94a3b8" />,
    title: 'Story Creator',
    description: 'Design vertical story content with text overlays and stickers',
    action: null,
    comingSoon: true,
  },
  {
    id: 'stitched-video',
    icon: <Icon.Film size={28} color="#4f46e5" />,
    title: 'Stitched Video Editor',
    description: 'Append one clip onto many videos at once, with optional speech-to-text captions',
    action: '/creator-studio/stitched-video',
    comingSoon: false,
  },
];

function CreatorStudio() {
  const navigate = useNavigate();

  return (
    <MainStructure activeItem="creator-studio">
      <div className="container-fluid p-0">

        {/* Page Header */}
        <div className="mb-4">
          <h1
            className="h3 mb-1"
            style={{ fontWeight: 800, letterSpacing: '-0.3px', color: '#0f172a' }}
          >
            Creator Studio
          </h1>
          <p className="mb-0 small" style={{ color: '#64748b' }}>
            Create stunning content for your audience
          </p>
        </div>

        {/* Tool Cards Grid */}
        <div className="row g-3">
          {toolCards.map((tool) => (
            <div key={tool.id} className="col-12 col-sm-6 col-xl-4">
              <div
                style={{
                  background: '#fff',
                  border: tool.comingSoon ? '1px solid #e8edf2' : '1px solid #e8edf2',
                  borderRadius: 12,
                  padding: 24,
                  height: '100%',
                  display: 'flex',
                  flexDirection: 'column',
                  opacity: tool.comingSoon ? 0.7 : 1,
                  position: 'relative',
                  transition: 'box-shadow 0.15s',
                }}
              >
                {tool.comingSoon && (
                  <span
                    style={{
                      position: 'absolute',
                      top: 16,
                      right: 16,
                      background: '#f1f5f9',
                      color: '#64748b',
                      fontSize: 11,
                      fontWeight: 700,
                      letterSpacing: '0.05em',
                      textTransform: 'uppercase',
                      borderRadius: 6,
                      padding: '3px 9px',
                      border: '1px solid #e2e8f0',
                    }}
                  >
                    Coming soon
                  </span>
                )}

                {/* Icon */}
                <div
                  style={{
                    width: 52,
                    height: 52,
                    borderRadius: 12,
                    background: tool.comingSoon ? '#f8fafc' : '#eef2ff',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    marginBottom: 16,
                  }}
                >
                  {tool.icon}
                </div>

                {/* Title + Description */}
                <h2
                  className="mb-2"
                  style={{ fontSize: 16, fontWeight: 700, color: tool.comingSoon ? '#94a3b8' : '#0f172a', margin: 0 }}
                >
                  {tool.title}
                </h2>
                <p
                  className="mb-0"
                  style={{ fontSize: 13, color: '#64748b', lineHeight: 1.6, flex: 1 }}
                >
                  {tool.description}
                </p>

                {/* Action */}
                {!tool.comingSoon && (
                  <button
                    onClick={() => navigate(tool.action)}
                    style={{
                      marginTop: 20,
                      background: '#4f46e5',
                      color: '#fff',
                      border: 'none',
                      borderRadius: 9,
                      padding: '9px 20px',
                      fontWeight: 600,
                      fontSize: 13,
                      cursor: 'pointer',
                      alignSelf: 'flex-start',
                      display: 'flex',
                      alignItems: 'center',
                      gap: 7,
                    }}
                  >
                    Get Started
                    <Icon.ArrowRight size={14} strokeWidth={2.5} />
                  </button>
                )}
              </div>
            </div>
          ))}
        </div>
      </div>
    </MainStructure>
  );
}

export default CreatorStudio;
